/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-console */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import {
  Typography, Grid, Card, Divider, Snackbar,
  Tabs,
  Tab,
  Badge,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import Alert from '@material-ui/lab/Alert';
import clsx from 'clsx';
import groupServices from '../../../redux/services/groupServices';
import companyServices from '../../../redux/services/companyServices';

const moment = require('moment');

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    minHeight: '250px',
  },
  semesterDataContainer: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  examDataContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    madingBottom: 15,
  },
  semesterTitle: {
    padding: '1em',
    textAlign: 'left',
    fontWeight: 'bold',
    maxHeight: 50,
    fontSize: '1.2rem', // taille personnalisée sans changer le h2
  },
  semesterSubTitle: {
    fontSize: '15px',
  },
  cardHeader: {
    backgroundColor: theme.palette.primary.main,
    color: '#FFF',
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  cardBody: {
    width: '90%',
    height: '100%',
    margin: 'auto',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
  },
  smallPadding: {
    paddingBottom: 15,
    paddingTop: 15,
  },
  cardBodyWeb: {
    height: '80%',
  },
  center: {
    textAlign: 'center',
    margin: 'auto',
    width: '100%',
    height: '100%',
  },
  midContainer: {
    height: 'min-content',
  },
  title: {
    padding: '1em',
    textAlign: 'left',
    maxHeight: 50,
    fontWeight: 'bold',
  },
  boldTitle: {
    paddingRight: '1em',
    maxHeight: 50,
    fontWeight: 'bold',
  },
  actionArea: {
    width: '100%',
    height: '100%',
  },
  subTitle: {
    paddingBottom: '0.5em',
  },
}));

const FormatDate = (date, format) => {
  const formatedDate = date ? moment(date).format(format) : '';
  return formatedDate;
};

const getGap = (date1, date2, additionalTime) => {
  const dateDiff = new Date(date2) - new Date(date1);
  const diffMins = Math.round(dateDiff / 60 / 1000); // minutes
  let hoursDiff = Math.round((diffMins - (diffMins % 60)) / 60);
  const daysDiff = hoursDiff / 24;
  hoursDiff %= 24;
  return `${daysDiff >= 1 ? `${Math.round(daysDiff)} day${daysDiff > 1 ? '(s)' : ''} ` : ''}
  ${hoursDiff >= 1 ? `${hoursDiff}h` : ''}${diffMins % 60 < 10 && diffMins % 60 > 0 ? '0' : ''}
  ${diffMins % 60 > 0 ? `${diffMins % 60}min` : ''}
  ${additionalTime && additionalTime > 0 ? ` + ${additionalTime}min extra time` : ''}`;
};

const ExamsDates = ({ company, userData }) => {
  const classes = useStyles();
  const buttonSL = clsx({
    [classes.root]: false,
  });
  const [semesterData, setSemesterData] = useState(null);
  const [examData, setExamData] = useState([]);
  const [groups, setGroups] = useState([]);
  const [option, setOption] = useState(company.isCompany && company.isCompany === true ? 'Course' : 'Semesters');
  const [errorSnackBar, setErrorSnackBar] = useState(null);
  const { innerWidth: width } = window;
  const isSmallScreen = width < 450;

  useEffect(() => {
    if (examData.length > 0) {
      setOption('Exams');
    }
  }, [examData.length]);

  useEffect(() => {
    if (option === 'Exams') {
      const tmp = [];
      const today = new Date();
      today.setHours(1);
      for (const _group in groups) {
        const group = groups[_group];
        // eslint-disable-next-line max-len
        if (group.elearning && group.elearning.elearningOptions && group.level === 1 && (userData.semester === group.semester || (userData.catchUp && userData.catchUp.includes(group.semester)))) {
          group.elearning.elearningOptions.forEach((_option) => {
            if (new Date(_option.examBegin).getTime() > today.getTime()) {
              tmp.push({ ..._option, semester: group.semester });
            }
          });
        }
      }
      if (examData.length === 0 && tmp.length > 0) {
        setExamData(tmp);
      }
    }
  }, [groups, option, examData]);

  useEffect(async () => {
    const groupsDataByCompany = JSON.parse(localStorage.getItem('groupsDataByCompany'));
    const today = new Date();
    if (!groupsDataByCompany || today > new Date(groupsDataByCompany?.date)) {
      await groupServices.getGroupsDataByCompagny(company._id)
        .then((res) => {
          if (res.data) {
            setGroups(res.data);
            const date = new Date();
            date.setDate(date.getDate() + 1);
            localStorage.setItem('groupsDataByCompany', JSON.stringify({ date, data: res.data }));
          }
        })
        .catch(() => {
          setErrorSnackBar({ code: 1101, message: 'Missing groups data.', severity: 'error' });
        });
    } else {
      setGroups(groupsDataByCompany.data);
    }
  }, []);

  useEffect(async () => {
    // const companyDataById = JSON.parse(localStorage.getItem('companyDataById'));
    const companyDataById = null;
    const today = new Date();
    if (!companyDataById || today > new Date(companyDataById?.date)) {
      await companyServices.getCompanyDataById(company._id)
        .then((res) => {
          if (res.semesters && res.semesters.length > 0) {
            let actualSemester = null;
            let nextSemester = null;
            res.semesters.forEach((semester) => {
              if (semester.semester === userData.semester) {
                actualSemester = semester;
              } else if (semester.semester === userData.semester + 1) {
                nextSemester = semester;
              }
            });
            let resSemester = actualSemester;
            const date = new Date();
            if (!nextSemester) {
              resSemester = actualSemester;
            } else {
              const endDate = new Date(actualSemester.endDate);
              if (date.getTime() >= endDate.getTime()) {
                resSemester = nextSemester;
              }
            }
            setSemesterData(resSemester);
            date.setDate(date.getDate() + 1);
            localStorage.setItem('companyDataById', JSON.stringify({ date, data: resSemester }));
          }
        });
    } else {
      setSemesterData(companyDataById.data);
    }
  }, [company]);

  return (
    <Card container className={classes.root}>
      <Snackbar
        open={errorSnackBar !== null}
        onClose={() => setErrorSnackBar(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          severity={errorSnackBar?.severity || 'info'}
          variant="filled"
          onClose={() => setErrorSnackBar(null)}
        >
          {`Error ${errorSnackBar?.code}: ${errorSnackBar?.message}`}
        </Alert>
      </Snackbar>

      <Card className={classes.actionArea}>
        <Grid container direction="row" className={classes.center}>
          <Grid item md={12} className={classes.cardHeader}>
            <Tabs
              value={option}
              TabIndicatorProps={{ style: { backgroundColor: '#fff' } }}
              centered
              selected
              variant="fullWidth"
              style={{ width: '100%', height: '100%' }}
              className={buttonSL}
            >
              <Tab
                key="Semesters"
                onClick={() => setOption('Semesters')}
                value={company.isCompany ? 'Course' : 'Semesters'}
                label={(
                  <div style={{ display: 'flex', flexDirection: 'row', height: '100%' }}>
                    <Typography>{company.isCompany ? 'Course' : 'Semesters'}</Typography>
                  </div>
            )}
              />
              <Tab
                key="Exams"
                onClick={() => setOption('Exams')}
                value="Exams"
                label={(
                  <div style={{ display: 'flex', flexDirection: 'row', height: '100%' }}>
                    <Typography>Exams</Typography>
                    <Badge
                      badgeContent={examData.length}
                      sx={{
                        '& .MuiBadge-badge': {
                          backgroundColor: '#003366',
                          color: '#FFFFFF',
                        },
                      }}
                      style={{ marginLeft: 15 }}
                    />
                  </div>
            )}
              />
            </Tabs>
          </Grid>

          <Grid
            container
            direction="column"
            className={[
              classes.cardBody,
              !isSmallScreen ? classes.cardBodyWeb : null,
              !examData || examData.length <= 2 ? classes.smallPadding : null,
            ]}
            style={{ display: 'flex', flexDirection: 'column' }}
          >
            {option === 'Semesters' ? (
              <section
                className={classes.semesterDataContainer}
                aria-label={company.isCompany ? 'Your course information' : `Semester ${semesterData?.semester || ''} information`}
              >
                {semesterData ? (
                  <>
                    <Typography component="h3" className={classes.semesterTitle} style={{ marginBottom: 15 }}>
                      {company.isCompany ? 'Your course' : `Semester ${semesterData.semester},`}
                    </Typography>
                    <Typography className={classes.semesterSubTitle}>
                      from
                      {' '}
                      <time dateTime={semesterData.beginDate}>
                        {FormatDate(semesterData.beginDate, 'DD MMMM YYYY')}
                      </time>
                      {' '}
                      to
                      {' '}
                      <time dateTime={semesterData.endDate}>
                        {FormatDate(semesterData.endDate, 'DD MMMM YYYY')}
                        {' '}
                        23:00PM
                      </time>
                    </Typography>
                    {semesterData.catchUpDate && (
                    <Typography component="p" className={classes.semesterSubTitle}>
                      End of the second session:
                      {' '}
                      <time dateTime={semesterData.catchUpDate}>
                        {FormatDate(semesterData.catchUpDate, 'DD MMMM YYYY')}
                      </time>
                    </Typography>
                    )}
                  </>
                ) : (
                  <Typography>Semester dates will be communicated later.</Typography>
                )}
              </section>
            ) : (
              <section
                className={classes.semesterDataContainer}
                aria-label="Scheduled exams"
              >
                {examData.length > 0 ? (
                  <div className={classes.examDataContainer}>
                    <Typography component="h2" className={classes.semesterTitle}>
                      {`Scheduled exam${examData.length > 1 ? 's' : ''}:`}
                    </Typography>
                    <Divider style={{ margin: 17 / examData.length }} />
                    {examData
                      .sort((a, b) => (new Date(a.examBegin).getTime() > new Date(b.examBegin).getTime() ? 1 : -1))
                      .slice(0, 3)
                      .map((exam) => (
                        <div key={exam._id}>
                          <Typography className={classes.semesterSubTitle}>
                            {`Semester ${exam.semester} ${exam.modality} ${exam.catchUp ? 'rattrap. ' : ''}`}
                          </Typography>
                          <Typography className={classes.semesterSubTitle}>
                            <time dateTime={exam.examBegin}>
                              {FormatDate(exam.examBegin, 'DD/MM/YYYY')}
                              {' '}
                              at
                              {' '}
                              {FormatDate(exam.examBegin, 'HH:mm')}
                            </time>
                            {' '}
                            for
                            {' '}
                            {getGap(exam.examBegin, exam.examEnd, userData.additionalTime)}
                          </Typography>
                        </div>
                      ))}
                  </div>
                ) : (
                  <Typography>No exam scheduled for now.</Typography>
                )}
              </section>
            )}
          </Grid>
        </Grid>
      </Card>
    </Card>
  );
};

ExamsDates.propTypes = {
  company: PropTypes.object.isRequired,
  userData: PropTypes.object.isRequired,
};

function mapState(state) {
  const { userData } = state.user;
  const { company } = userData;

  return { company, userData };
}
export default connect(mapState, null)(ExamsDates);
